"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class StringArray extends Array {
    constructor(value) {
        if (typeof value == 'number') {
            super(value);
        }
        else {
            super();
            if (value) {
                const arr = typeof value === 'string' ? value.split(',') : value;
                this.push(...arr.filter(i => i));
            }
        }
    }
}
exports.StringArray = StringArray;
class FieldArray extends Array {
    constructor(value) {
        if (typeof value == 'number') {
            super(value);
        }
        else {
            super();
            if (value) {
                const arr = typeof value === 'string' ? value.split(',') : value;
                this.push(...arr.filter(i => i));
            }
        }
    }
}
exports.FieldArray = FieldArray;
class NumberArray extends Array {
    constructor(value, ..._) {
        if (typeof value == 'number') {
            super(value);
        }
        else {
            super();
            if (value) {
                const arr = typeof value === 'string' ? value.split(',') : value;
                this.push(...arr.filter(i => i).map(i => +i));
            }
        }
    }
}
exports.NumberArray = NumberArray;
//# sourceMappingURL=array.models.js.map